<template>
    <div
        class="selected"
        :style="`border:1px solid ${item.isSelected ? $appColors.warning : '#f1a135'}`"
        :class="{'isSelect': item.isSelected}">
        <div class="flex-container">
            <v-icon
				color="warning"
				:disabled="!item.isSelected"
			>
				check_circle
			</v-icon>
			<p
				v-if="item.name.length <= 30"
				class="tw-m-0 tw-text-center"
				:style="`color:${$appColors.warning}`"
			>{{item.name}}</p>
			<p
				v-else
				class="tw-m-0 tw-text-center"
				:style="`color:${$appColors.warning}`"
			>{{item.name | limitTo(30) }}</p>
		</div>
    </div>
</template>

<script>
function created() {
}

export default {
	name: 'card-selected',
	created,
	props: {
		item: {
			type: Object,
			default: () => {},
		},
	},
};
</script>

<style lang="scss" scoped>
.selected {
		display: flex;
		flex-direction: row;
		background: none;
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 12px;
		cursor: pointer;
		padding: 11px;
		margin: 0;
		width: 170px;
		height: 102px;

		&:hover {
			border: 1px solid map-get($colors, success);
		}

		&.active {
			background-color: map-get($colors, secondary);
		}

		&-line {
			margin: 10px 0;
			width: 70%;
		}

		&-text {
			font-size: 11px;
			text-transform: uppercase;
		}
		.flex-container {
			display: flex;
			align-items: center;
			justify-content: space-around;
			width: 100%;
		}
		p {
			font-weight: bold;
		}
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/evaluation/card-selected.vue